<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c02"><a id="page02"></a><strong>Things That Go Bump In the Night</strong></h1>
<p class="nonindent">A middle-aged woman in England was awakened by a strange noise in her house and immediately called the police. The bobbies arrived promptly and scoured the residence looking for the source of the sound. The woman’s face went from “white with fear” to “red with embarrassment” when the police discovered an intruder of another sort had caused the noise; the woman’s sex toy had gone off in her nightstand. A spokesperson for the police said the officers on call had a difficult time keeping a straight face when they apprehended the apparatus. I suppose the term “assault and battery” would apply here—for her next assault she’ll need new batteries.<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
<div class="block">
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L02_r1.jpg"/></p>
<p class="center"><strong><em>In Detroit, Michigan, it is unlawful to use any kind of pennant to decorate your car in order to be noticed or to impress your girlfriend.</em></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c02_r1.vue?7b1839d6